<template>
  <a-card :bordered="false">
    <!-- 查询区域 -->
    <div class="table-page-search-wrapper">
      <a-form layout="inline" @keyup.enter.native="searchQuery">
        <a-row :gutter="24">
          <a-col :md="6" :sm="8">
            <a-form-item label="content">
              <a-input placeholder="请输入content" v-model="queryParam.content"></a-input>
            </a-form-item>
          </a-col>

          <a-col :md="5" :sm="8" >
            <a-form-item label="api类型" style="left: 10px">
              <j-dict-select-tag v-model="queryParam.apiType" placeholder="api类型" dictCode="hhemp_aicsp_apitype"/>
            </a-form-item>
          </a-col>
          <a-col :md="5" :sm="8" >
            <a-form-item label="convertTextToSpeech" style="left: 10px">
              <j-dict-select-tag v-model="queryParam.convertTextToSpeech" placeholder="convertTextToSpeech" dictCode="hhemp_isthird"/>
            </a-form-item>
          </a-col>

          <span style="float: left;overflow: hidden;" class="table-page-search-submitButtons">
            <a-col :md="6" :sm="24" >
                <a-button type="primary"  @click="searchQuery" icon="search">查询</a-button>
                <a-button type="primary"  @click="searchReset" icon="reload" style="margin-left: 8px;left: 10px">重置</a-button>
            </a-col>
          </span>

        </a-row>
      </a-form>
    </div>
    <!-- 查询区域-END -->

    <!-- 操作按钮区域 -->
    <div class="table-operator">
      <a-button @click="handleAdd" type="primary" icon="plus">接口调用测试</a-button>
      <a-button @click="handleQandA" type="primary" icon="plus">问答</a-button>
<!--      <a-button type="primary" icon="download" @click="handleExportXls('emp_aicsp_log')">导出</a-button>
      <a-upload name="file" :showUploadList="false" :multiple="false" :headers="tokenHeader" :action="importExcelUrl" @change="handleImportExcel">
        <a-button type="primary" icon="import">导入</a-button>
      </a-upload>
      &lt;!&ndash; 高级查询区域 &ndash;&gt;
      <j-super-query :fieldList="superFieldList" ref="superQueryModal" @handleSuperQuery="handleSuperQuery"></j-super-query>
      <a-dropdown v-if="selectedRowKeys.length > 0">
        <a-menu slot="overlay">
          <a-menu-item key="1" @click="batchDel"><a-icon type="delete"/>删除</a-menu-item>
        </a-menu>
        <a-button style="margin-left: 8px"> 批量操作 <a-icon type="down" /></a-button>
      </a-dropdown>-->
    </div>

    <!-- table区域-begin -->
    <div>
<!--      <div class="ant-alert ant-alert-info" style="margin-bottom: 16px;">
        <i class="anticon anticon-info-circle ant-alert-icon"></i> 已选择 <a style="font-weight: 600">{{ selectedRowKeys.length }}</a>项
        <a style="margin-left: 24px" @click="onClearSelected">清空</a>
      </div>-->

      <a-table
        ref="table"
        size="middle"
        :scroll="{x:1000}"
        bordered
        rowKey="id"
        :columns="columns"
        :dataSource="dataSource"
        :pagination="ipagination"
        :loading="loading"
        class="j-table-force-nowrap"
        @change="handleTableChange">

        <div slot="expandedRowRender" slot-scope="record" style="margin: 0">
          <div style="margin-bottom: 5px"><a-badge status="success" style="vertical-align: middle;"/><span style="vertical-align: middle;">content:{{ record.content }}</span></div>
          <div><a-badge status="processing" style="vertical-align: middle;"/><span style="vertical-align: middle; word-break: break-all;white-space: pre-wrap;">响应结果:{{ record.responseResult }}</span></div>
        </div>
        <!-- 字符串超长截取省略号显示-->
        <span slot="logContent" slot-scope="text, record">
          <j-ellipsis :value="text" :length="20"/>
        </span>
        <span slot="contentSimpSlot" slot-scope="text, record">
          <div v-if="record.responseResult&&(record.apiType==='chatWithKnowledge'||record.apiType==='cspChatWithKnowledge')" >
           <a-button type="link" @click="showModal(record)">查看</a-button>
          </div>
          <div v-if="!(record.responseResult&&(record.apiType==='chatWithKnowledge'||record.apiType==='cspChatWithKnowledge'))" >
            <span>无</span>
          </div>
        </span>
        <span slot="contentAudioSlot" slot-scope="text, record">
            <div v-if="record.responseResult&&record.convertTextToSpeech==='1'" >
              <a-button type="link" @click="showModal2(record)">播放</a-button>
            </div>
           <div v-if="!(record.responseResult&&record.convertTextToSpeech==='1')" >
            <span>无</span>
          </div>
        </span>
        <span slot="processTypeSlot" slot-scope="text, record">
            <div v-if="record.responseResult&&record.apiType==='chatWithKnowledge'" >
              {{JSON.parse(record.responseResult).processType}}
            </div>
           <div v-if="!(record.responseResult&&record.apiType==='chatWithKnowledge')" >
            <span>无</span>
          </div>
        </span>

        <template slot="htmlSlot" slot-scope="text">
          <div v-html="text"></div>
        </template>
        <template slot="imgSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无图片</span>
          <img v-else :src="getImgView(text)" height="25px" alt="" style="max-width:80px;font-size: 12px;font-style: italic;"/>
        </template>
        <template slot="fileSlot" slot-scope="text">
          <span v-if="!text" style="font-size: 12px;font-style: italic;">无文件</span>
          <a-button
            v-else
            :ghost="true"
            type="primary"
            icon="download"
            size="small"
            @click="downloadFile(text)">
            下载
          </a-button>
        </template>

        <span slot="action" slot-scope="text, record">
          <a @click="handleEdit(record)">编辑</a>

          <a-divider type="vertical" />
          <a-dropdown>
            <a class="ant-dropdown-link">更多 <a-icon type="down" /></a>
            <a-menu slot="overlay">
              <a-menu-item>
                <a @click="handleDetail(record)">详情</a>
              </a-menu-item>
              <a-menu-item>
                <a-popconfirm title="确定删除吗?" @confirm="() => handleDelete(record.id)">
                  <a>删除</a>
                </a-popconfirm>
              </a-menu-item>
            </a-menu>
          </a-dropdown>
        </span>

      </a-table>
    </div>

    <emp-aicsp-log-modal ref="modalForm" @ok="modalFormOk"></emp-aicsp-log-modal>
    <QandA ref="modalQandA" ></QandA>
    <a-modal
      v-model:visible="isModalVisible"
      title="查看详细信息"
      @ok="handleOk"
      @cancel="handleCancel"
    >
      <p>{{ modalText }}</p>
    </a-modal>
    <a-modal
      v-model:visible="isModalVisible2"
      title="播放"
      @ok="handleOk2"
      @cancel="handleCancel2"
    >
      <audio ref="audioElement" :src="modalSrc" controls></audio>
    </a-modal>
  </a-card>
</template>

<script>

  import '@/assets/less/TableExpand.less'
  import { mixinDevice } from '@/utils/mixin'
  import { JeecgListMixin } from '@/mixins/JeecgListMixin'
  import EmpAicspLogModal from './modules/EmpAicspLogModal'
  import QandA from './modules/QandA'

  export default {
    name: 'EmpAicspLogList',
    mixins:[JeecgListMixin, mixinDevice],
    components: {
      EmpAicspLogModal,
      QandA
    },
    data () {
      return {
        description: 'emp_aicsp_log管理页面',
        // 表头
        columns: [
          {
            title: '#',
            dataIndex: '',
            key:'rowIndex',
            width:60,
            align:"center",
            customRender:function (t,r,index) {
              return parseInt(index)+1;
            }
          },
          {
            title:'api类型',
            align:"center",
            dataIndex: 'apiType_dictText',
            width: 100,
            customCell: () => {
              return {
                style: {
                  'text-align': 'left'
                },
              };
            },
          },
          /*{
            title:'请求java方法',
            align:"center",
            dataIndex: 'method'
          },*/
          {
            title:'content',
            align:"center",
            dataIndex: 'content',
            width: 200,
            scopedSlots: { customRender: 'logContent' },
            customCell: () => {
              return {
                style: {
                  'text-align': 'left'
                },
              };
            },
          },
          {
            title:'文本',
            align:"center",
            dataIndex: 'contentSimp',
            width: 50,
            scopedSlots: { customRender: 'contentSimpSlot' },
          },
          {
            title:'语音',
            align:"center",
            dataIndex: 'contentAudio',
            width: 50,
            scopedSlots: { customRender: 'contentAudioSlot' },
          },
          {
            title:'category',
            align:"center",
            dataIndex: 'category_dictText',
            width: 100,
          },
          {
            title:'Process Type',
            align:"center",
            dataIndex: 'processType',
            width: 100,
            scopedSlots: { customRender: 'processTypeSlot' },
          },
          {
            title:'lang',
            align:"center",
            dataIndex: 'lang_dictText',
            width: 60,
          },
          {
            title:'convertTextToSpeech',
            align:"center",
            dataIndex: 'convertTextToSpeech_dictText',
            width: 100,
          },
          {
            title:'操作用户账号',
            align:"center",
            dataIndex: 'userid',
            width: 100,
          },
          {
            title:'操作用户名称',
            align:"center",
            dataIndex: 'username',
            width: 100,
          },
          /*{
            title:'请求路径',
            align:"center",
            dataIndex: 'requestUrl'
          },
          {
            title:'请求参数',
            align:"center",
            dataIndex: 'requestParam'
          },*/
          /*{
            title:'请求类型',
            align:"center",
            dataIndex: 'requestType'
          },
          {
            title:'耗时',
            align:"center",
            dataIndex: 'costTime'
          },*/
          /*{
            title:'响应结果',
            align:"center",
            dataIndex: 'responseResult'
          },*/
          /*{
            title:'删除标准',
            align:"center",
            dataIndex: 'delFlag'
          },*/
          /*{
            title: '操作',
            dataIndex: 'action',
            align:"center",
            fixed:"right",
            width:147,
            scopedSlots: { customRender: 'action' }
          }*/
        ],
        url: {
          list: "/hhemp/aicsp/empaicsplogs",
          delete: "/hhemp/aicsp/empaicsplog",
          deleteBatch: "/hhemp/aicsp/empaicsplog/batch",
          exportXlsUrl: "/hhemp/aicsp/export-xls",
          importExcelUrl: "hhemp/aicsp/import-excel",
          
        },
        dictOptions:{},
        superFieldList:[],
        isModalVisible: false,
        modalText: '',
        isModalVisible2: false,
        modalSrc: '',
      }
    },
    created() {
    this.getSuperFieldList();
    },
    computed: {
      importExcelUrl: function(){
        return `${window._CONFIG['domianURL']}/${this.url.importExcelUrl}`;
      },
    },
    methods: {
      initDictConfig(){
      },
      getSuperFieldList(){
        let fieldList=[];
        fieldList.push({type:'string',value:'apiType',text:'api类型'})
        fieldList.push({type:'string',value:'userid',text:'操作用户账号'})
        fieldList.push({type:'string',value:'username',text:'操作用户名称'})
        fieldList.push({type:'string',value:'method',text:'请求java方法'})
        fieldList.push({type:'string',value:'content',text:'content'})
        fieldList.push({type:'string',value:'category',text:'category'})
        fieldList.push({type:'string',value:'lang',text:'lang'})
        fieldList.push({type:'string',value:'convertTextToSpeech',text:'convertTextToSpeech'})
        fieldList.push({type:'string',value:'requestUrl',text:'请求路径'})
        fieldList.push({type:'string',value:'requestParam',text:'请求参数'})
        fieldList.push({type:'string',value:'requestType',text:'请求类型'})
        fieldList.push({type:'int',value:'costTime',text:'耗时'})
        fieldList.push({type:'string',value:'responseResult',text:'响应结果'})
        fieldList.push({type:'string',value:'delFlag',text:'删除标准'})
        this.superFieldList = fieldList
      },

      // 显示模态框
      showModal(record) {
        try {
          this.modalText = JSON.parse(record.responseResult).content;
          this.isModalVisible = true;
        } catch (e) {
          this.$message.warning("无法获取到content");
        }
      },

      // 处理模态框确认
      handleOk() {
        this.isModalVisible = false;
        this.modalText = '';
      },

      // 处理模态框取消
      handleCancel() {
        this.isModalVisible = false;
        this.modalText = '';
      },
      // 显示模态框
      showModal2(record) {
        try {
          this.modalSrc = "data:audio/wav;base64," + JSON.parse(record.responseResult).base64Audio;
          this.isModalVisible2 = true;
        } catch (e) {
          this.$message.warning("无法获取到audio");
        }

      },

      // 处理模态框确认
      handleOk2() {
        this.isModalVisible2 = false;
        this.modalSrc = '';
      },

      // 处理模态框取消
      handleCancel2() {
        this.isModalVisible2 = false;
        this.modalSrc = '';
      },
      handleQandA(){
        this.$refs.modalQandA.qanda();
      }
    }
  }
</script>
<style scoped>
  @import '~@assets/less/common.less';
</style>
